import i18next, { Resource } from 'i18next'
import { initReactI18next } from 'react-i18next'
import HttpBackend, { HttpBackendOptions } from 'i18next-http-backend'
import { defaultNamespace, supportedLngs, fallbackLng, showI18nStringsPostProcessor } from './sharedConfig'
import addFormatters, { addCurrencyFormatter } from './formatters'

const { language, regionCode, currencyCode, initialResources, showI18NStrings } = window.__I18N__ as {
  language: string,
  regionCode: string,
  currencyCode: string,
  showI18NStrings: boolean,
  initialResources: Resource,
}

i18next
  .use(initReactI18next)
  .use(HttpBackend)
  .use(showI18nStringsPostProcessor)
  .init<HttpBackendOptions>({
    ns: defaultNamespace,
    lng: language,
    supportedLngs,
    fallbackLng,
    partialBundledLanguages: true,
    resources: initialResources,
    postProcess: showI18NStrings ? ['showI18nStrings'] : undefined,
    interpolation: {
      escapeValue: false, // not needed for react as it escapes by default
    },
    backend: {
      loadPath: '/locales/{{lng}}/{{ns}}.json',
      addPath: '/locales/add/{{lng}}/{{ns}}',
    },
  })

addFormatters(i18next)
addCurrencyFormatter(i18next, regionCode, currencyCode)

export default i18next
